import CollectionJobStates from "./CollectionJobStates";
import { mountVueComponent } from "utils/mountVueComponent";

export const mountCollectionJobStates = mountVueComponent(CollectionJobStates);
